module.exports = __webpack_public_path__ + "img/reduced-cost.0e6f4c42.svg";